import {interopDefault} from '@/utils/helpers'
const SimpleTourSearchPage = () => interopDefault(import('~/pages/simpleTours/SimpleTourSearchPage'))
const SimpleTourPage = () => interopDefault(import('~/pages/simpleTours/SimpleTourPage'))
const SimpleTourBookingPage = () => interopDefault(import('~/pages/simpleTours/SimpleTourBookingPage'))
const SimpleTourConfirmationPage = () => interopDefault(import('~/pages/simpleTours/SimpleTourConfirmationPage'))

export default [
    {
        path: '/search/simpleTour',
        component: SimpleTourSearchPage,
        name: 'simpleTourSearch',
        meta: {
            unwrapped: true,
        },
    },
    {
        path: '/simpleTour',
        component: SimpleTourPage,
        name: 'simpleTour',
        beforeEnter: (to, from, next) => {
            if (!to.query.name) {
                next({name: 'home'})
            }
            next()
        },
        meta: {
            unwrapped: true,
            validate: route => !!route.query.name,
        },
    },
    {
        path: '/simpleTour/booking',
        component: SimpleTourBookingPage,
        name: 'simpleTourBooking',
        beforeEnter: (to, from, next) => {
            if (!to.query.offerKey) {
                next({name: 'home'})
            }
            next()
        },
        meta: {
            unwrapped: true,
            validate: route => !!route.query.offerKey,
        },
    },
    {
        path: '/simpleTour/confirmation',
        component: SimpleTourConfirmationPage,
        name: 'simpleTourConfirmation',
        meta: {
            unwrapped: true,
        },
    },
]
